import { FeatureFlag, isEnabled } from '@monolith/legacy/services/features';
import { BrandFormType } from '@monolith/legacy/types/brand-form-type';
import { getFunnelEntry } from '@monolith/legacy/services/signup/registration-funnel-url';
import { trackBrandRegistrationClick } from '@monolith/legacy/services/signup/brand-registration-tracking';

export function isBrandRegistrationLandingPageEnabled(): boolean {
  return !isEnabled(FeatureFlag.DisableBrandRegistrationLandingPage);
}

export async function openBrandRegistrationEntry(
  openAuthPopin: (view: BrandFormType) => void,
): Promise<void> {
  // Swallowed where the promise is created rather than where it is awaited, so every exit
  // below is covered: the popin path returns without awaiting, and a rejected
  // Analytics.track would otherwise surface there as an unhandled rejection.
  const trackingSent = trackBrandRegistrationClick('home_cta_clicked').catch(() => {});

  if (!isBrandRegistrationLandingPageEnabled()) {
    openAuthPopin(BrandFormType.BrandRegister);
    return;
  }

  // Only this branch waits, and not for tidiness: the assignment below unloads the page,
  // which would cut off a click still in flight. Opening the popin tears down nothing.
  await trackingSent;

  window.location.href = getFunnelEntry('brand').path;
}
